import { RouteConfig } from '@/lib/routes';
import { UserSchema } from '@/lib/types';
import { ReactNode } from 'react';
import { Location } from 'react-router';

export const NavigationHeight = 90;

export type MenuOption =
  | {
      ariaLabel: string;
      label: ReactNode;
      path: string;
    }
  | {
      ariaLabel: string;
      label: ReactNode;
      key: string;
      onClick: () => void;
    };

export const useMatch = ({
  location,
  to,
  options,
}: {
  location: Location;
  to?: string;
  options?: MenuOption[];
}) => {
  return (
    (to === '/' && location.pathname === '/') ||
    options?.some(
      (option) =>
        'path' in option &&
        (to
          ? location.pathname === to + '/' + option.path
          : location.pathname === option.path),
    )
  );
};

export const isRouteAllowed = (
  user: UserSchema,
  route: RouteConfig,
) => {
  return (
    route.menuLabel &&
    route.ariaLabel &&
    (!route.allowedRoles?.length ||
      user?.roles.some((r) =>
        route.allowedRoles?.includes(r.name),
      )) &&
    (!route.requiredPermissions?.length ||
      route.requiredPermissions.every((p) =>
        user?.permissions?.some((perm) => perm.key === p),
      ))
  );
};
